import { useSelector } from 'react-redux';
import { useMemo } from 'react';

import { ID8_GEN_TYPES } from '../../constants';

const useIsMessagesGenerating = () => {
  const activeGeneratingStatuses = useSelector((state) => state.id8.activeGeneratingStatuses);

  return useMemo(() => activeGeneratingStatuses[ID8_GEN_TYPES.IDEAS], [activeGeneratingStatuses]);
};

export default useIsMessagesGenerating;
